// Sembunyikan detail protokol mentah (frame hex, kode command, framing) dari console user.
const RULES = [
  /←/,
  /\b(?:[0-9A-F]{2}\s){3,}[0-9A-F]{2}\b/i,
  /[:>]\s*[0-9A-F]{10,}\b/i,
  /\b[A-Za-z_]+\((?:0x)?[0-9A-F]{2}(?:\s[0-9A-F]{2})?\)/,
  /^(Erase|Sektor|Sector|Page|Halaman) .*\b(OK|— OK)$/i,
  /^(TRMD )?Engine v\d/,
  /^Sync /,
  /ETB\/ETX|chunk 0x|\(0x1[23]\)|SAD|EAD|noparam/,
  /\b(sr|status)=[0-9A-F]{2,}/i,
];
export const isSensitiveLog = (msg) => typeof msg === 'string' && RULES.some((r) => r.test(msg));
